import * as React from 'react';
import cn from 'classnames';
import { Trans } from 'react-i18next';

import { ThemeConsumer } from '../theme';
import { Box } from '../box';
import { Icon } from '../icon';
import { Button } from '../button';
import { Text } from '../text';
import { can } from '../../utils/permissions';

export class CourseHeader extends React.Component {
  render() {
    const { history, showBackButton } = this.props;

    return (
      <ThemeConsumer>
        {(theme) => (
          <Box
            className={cn('programs-top-bar', {
              'programs-top-bar--visible': showBackButton || can(undefined, 'Course', 'create'),
            })}
            flexDirection="row"
          >
            {showBackButton && (
              <Button
                color="#E8EBEE"
                textColor="#A2ABBB"
                size="sm"
                type="button"
                block
                onClick={() => {
                  history.push('/courses/explore');
                }}
                title={({ textColor }) => (
                  <React.Fragment>
                    <Icon name="pba-arrow-left" size={25} color={textColor} />{' '}
                    <Text className="programs-top-bar__back__text">
                      <Trans>Back</Trans>
                    </Text>
                  </React.Fragment>
                )}
                className="programs-top-bar__back"
                id="btn_back"
              />
            )}
            {can(undefined, 'Course', 'create') ? (
              <Button
                type="button"
                color={theme.color.brand}
                size="sm"
                textColor="white"
                onClick={() => {
                  history.push(`/courses/create`);
                }}
                title={({ textColor }) => (
                  <React.Fragment>
                    <Text color={textColor} size={14} fontWeight="bold">
                      <Trans>Create New</Trans>
                    </Text>
                  </React.Fragment>
                )}
                className="programs-top-bar__create"
                id="btn_create-course"
              />
            ) : null}
          </Box>
        )}
      </ThemeConsumer>
    );
  }
}
